//User
export const authTypes = {
    LOGIN_DETAILS: "LOGIN_DETAILS",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    LOGIN_FAILURE: "LOGIN_FAILURE",
    REGISTER_DETAILS: "REGISTER_DETAILS",
    REGISTER_SUCCESS: "REGISTER_SUCCESS",
    REGISTER_FAILURE: "REGISTER_FAILURE",
    LOGOUT: "LOGOUT",
    LOADER: "LOADER",
  };
  